import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';
import axios from 'axios';
import JustValidate from 'just-validate';
// import { Rules } from "just-validate/dist/modules/interfaces";

declare let core_object: any;
declare let localize_object: any;

export default class registerUser{

    elModal: string;
    btnOpenModal: string;
    btnCloseModal: string;
    elForm: string;
    elFormAlert: string;
    elFormSuccess: string = 'success-comment-register';
    elFormBtn: string;
    elFormSpin: string = 'bgdrop-spin';

    url_api_modal: string;
    url_api_register: string;

    /**
     * Constructor
     * @param elModal 
     * @param btnOpenModal 
     * @param btnCloseModal 
     * @param elForm 
     * @param elFormEmail 
     * @param elFormPassword 
     * @param elFormAlert 
     * @param elFormBtn 
     */
    constructor(
        elModal: string,
        btnOpenModal: string,
        btnCloseModal: string,
        elForm: string,
        elFormAlert: string,
        elFormBtn: string
    ){
        
        this.elModal = elModal;
        this.btnOpenModal = btnOpenModal;
        this.btnCloseModal = btnCloseModal;
        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;

        this.url_api_modal = core_object.rest_urls.comments_signup_modal;

        this.url_api_register = core_object.rest_urls.comments_register;

    }

    /**
     * Get template
     */
    getTemplateModal(){
        
        const _that = this;
        const el = document.getElementById(this.btnOpenModal);

        el?.addEventListener("click", function(e){
            e.preventDefault();

            const containModal = document.getElementById(_that.elModal);

            if(containModal == null){
                
                const post_data = {
                    ajax_nonce: core_object.ajaxNonce,
                };
        
                const queryString = new URLSearchParams(post_data).toString();
                
                // Call ajax
                axios.post(_that.url_api_modal, queryString)
                    .then(function (response: any) {

                    let responseStatus: boolean = response.data.status;

                    if(responseStatus == true){

                        let getModal = response.data.template;
                        
                        $('body').append(getModal);

                        _that.showForm(el);

                    }

                    if(responseStatus == false){
                        
                        

                    }

                })
                .catch(function (error:any){

                    

                });
    
            }else{
                
                _that.showForm(el);

            }
 
        });

    }

    /**
     * Show form
     * @param el 
     */
    showForm(el: HTMLElement){
        
        const _that = this;

        const modal = _that.initModal();

        // Reset content modal
        this.resetContentModal();

        // Show modal
        modal.show();

        // Validate form
        const validation = _that.validateData();
        
        // Close modal
        const elClose = document.getElementById(_that.btnCloseModal);

        elClose?.addEventListener("click", function(e){
            e.preventDefault();
            
            // Destroy validation
            validation.destroy();

            // Remove disabled attribute
            el?.removeAttribute('disabled');

            // Modal Hide
            modal.hide();

        });

    }

    /**
     * Get modal
     * @param el 
     * @returns 
     */
    initModal(){

        const targetEl = document.getElementById(this.elModal) as HTMLElement | null;

        const modalOptions: ModalOptions = {
            placement: 'top-center',
            backdrop: 'static',
            backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-[60]'
        }

        const modal: ModalInterface = new Modal(targetEl, modalOptions);

        modal.hide();

        return modal;

    }

    /**
     * Validation data
     * @returns 
     */
    validateData() {

        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-color11-400',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#comment-signup-username', [
            {
                rule: 'required',
                errorMessage: core_object.modal_register.field_required,
            },
        ])
        .addField('#comment-signup-email', [
            {
                rule: 'required',
                errorMessage: core_object.modal_register.email_required,
            },
            {
                rule: 'email',
                errorMessage: core_object.modal_register.email_invalid,
            },
        ])
        .addField('#comment-signup-password', [
            {
                rule: 'required',
                errorMessage: core_object.modal_register.field_required,
            },
            {
                rule: 'strongPassword',
                errorMessage: core_object.modal_register.strong_password,
            },
        ])
        .addField('#comment-signup-password-confirm', [
            {
                rule: 'required',
                errorMessage: core_object.modal_register.field_required,
            }
        ])
        .addField('#comment-signup-policy', [
            {
                rule: 'required',
                errorMessage: core_object.modal_register.field_required,
            }
        ])    
        .onSuccess((event: any) => {
                
                event.preventDefault();

                // Send api
                _that.sendApi(event?.currentTarget, validation);
                
        });

        return validation;

    }

    /**
     * 
     * @param form Send Api
     */
    sendApi(form: HTMLFormElement, validation: JustValidate) {
        
        const _that = this;

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button send
        const btn = document.getElementById(this.elFormBtn) as HTMLInputElement | null;

        // Init post data
        const post_data = {
            ajax_nonce: core_object.ajaxNonce,
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = this.btnSpin();

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_register, queryString)
            .then(function (response: any) {

            // Remove alert box
            _that.removeAlertBox();
            
            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');
            
            // Response status
            let responseStatus: boolean = response.data.status;
                
            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = _that.alertBox(error);
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = _that.alertBox(errors);
                    form.prepend(alert);

                }
  
            }
            
            // True
            if(responseStatus == true){
                
                // Get message
                const message: string = response.data.message;
                
                // Create box mesaage
                const boxMessage = _that.successBox(message);

                // Append box message
                const wrapModal = document.getElementById('wrap-modal-comments-register') as HTMLElement | null;
                wrapModal?.append(boxMessage);

                // Reset form
                form.reset();

                // Destroy validation
                validation.destroy();

                // Hidden form
                form.classList.add('hidden');

            }

        })
        .catch(function (error: any) {
            
            // Reset content modal
            _that.resetContentModal();

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Reset content modal
     */
    protected resetContentModal(){
        
        const el = document.getElementById(this.btnOpenModal);
        
        // Set disabled attribute
        el?.setAttribute('disabled', '');

        // Remove class hidden
        const form = document.getElementById('signupCommentForm') as HTMLFormElement | null;
        form?.classList.remove('hidden');

        // Remove alert box
        this.removeAlertBox();

        // Remove message box
        const messageBox = document.getElementById(this.elFormSuccess) as HTMLElement | null;
        messageBox?.remove();
    
    }

    /**
     * Create spin
     * @returns 
     */
    btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

    /**
     * Alert Box
     * @param text 
     * @returns 
     */
    alertBox(text: string){

        const alert = document.createElement("div");

        alert.setAttribute('role', 'alert');
        alert.classList.add(this.elFormAlert, 'flex', 'basis-full', 'w-full', 'p-4', 'mb-4', 'rounded', 'fluid-text-sm', 'text-red-800', 'bg-red-50');
        alert.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mt-2 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        alert.innerHTML += '<div><span class="font-bold">' + localize_object.error + '</span> ' + text + '</div>';

        return alert;
        
    }

    /**
     * Success box
     * @param text 
     * @returns 
     */
    successBox(text: string){

        const elDiv = document.createElement("div");

        elDiv.setAttribute('id', this.elFormSuccess);
        elDiv.setAttribute('role', 'alert');
        elDiv.classList.add('flex', 'basis-full', 'w-full', 'p-4', 'mb-4', 'rounded', 'fluid-text-sm', 'bg-color20-500', 'text-white');
        elDiv.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mt-2 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        elDiv.innerHTML += '<span>' + text + '</span>';

        return elDiv;
        
    }

    /**
     * Remove alert box
     */
    removeAlertBox(){
        
        const targetModal = document.getElementById(this.elModal) as HTMLElement | null;

        if(targetModal !== null){
            
            const boxes = Array.from(targetModal.getElementsByClassName(this.elFormAlert)) as any;

            boxes.forEach(box => {

                box.remove();

            });
    
        }

    }

}